import type { User } from '@supabase/supabase-js'
import { createClient } from '@supabase/supabase-js'

// 环境变量验证
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env.local file.')
}

// 创建 Supabase 客户端实例
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // 存储配置
    storage: {
      getItem: (key: string) => {
        if (typeof window !== 'undefined') {
          return localStorage.getItem(key)
        }
        return null
      },
      setItem: (key: string, value: string) => {
        if (typeof window !== 'undefined') {
          localStorage.setItem(key, value)
        }
      },
      removeItem: (key: string) => {
        if (typeof window !== 'undefined') {
          localStorage.removeItem(key)
        }
      },
    },
  },
})

/**
 * 获取 Supabase 客户端实例
 * @returns Supabase 客户端
 */
export function useSupabase() {
  return supabase
}

/**
 * 获取 Supabase 认证客户端
 * @returns Supabase 认证客户端
 */
export function useSupabaseAuth() {
  return supabase.auth
}

/**
 * 获取 Supabase 存储客户端
 * @returns Supabase 存储客户端
 */
export function useSupabaseStorage() {
  return supabase.storage
}

/**
 * 获取 Supabase 数据库客户端
 * @returns Supabase 数据库客户端
 */
export function useSupabaseDatabase() {
  return supabase
}

/**
 * 获取当前用户信息
 * @deprecated 请直接使用 useUserStore().user 获取用户信息
 * 用户状态由 user store 统一管理，避免重复的认证状态监听
 * @returns 当前用户的响应式引用
 */
export function useSupabaseUser() {
  console.warn('useSupabaseUser is deprecated. Please use useUserStore().user instead.')
  const user = ref<User | null>(null)

  // 仅获取当前用户，不设置监听器
  supabase.auth.getUser().then(({ data }) => {
    user.value = data.user
  })

  return readonly(user)
}
